import { render } from "./EventsPage.vue?vue&type=template&id=8b0e2b3e"
import script from "./EventsPage.vue?vue&type=script&lang=js"
export * from "./EventsPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__